import React, { useCallback, useEffect, useState } from "react";
import { API } from "../../../utils/Apis";
import { showToast } from "../../../utils/helpers";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

interface PayOutItemType {
  id: string;
  userId: string;
  currency: string;
  errorMessage: string;
  grossAmount: number;
  metadata: {
    netAmount: number;
    platformFee: number;
    originalAmount: number;
  };
  netAmount: number;
  payoutDate: Date;
  platformFee: string;
  status: string;
  stripeAccountId: string;
  stripeFee: string;
  stripePayoutId: string;
  stripeTransferId: string;
  taxFee: number;
  createdAt: Date;
  updatedAt: Date;
}

interface PayoutDetailsType {
  itemId: string;
}

const PayoutDetails: React.FC<PayoutDetailsType> = ({ itemId }) => {
  const [detailsLoading, setDetailsLoading] = useState(true);
  const [payoutItem, setPayoutItem] = useState<PayOutItemType | null>();

  const getSinglePayout = useCallback(() => {
    API.getPayoutDetails(itemId)
      .then((res) => {
        if (res.type === "success") {
          setPayoutItem(res.data.payout);
        }
      })
      .catch((err) => {
        showToast("error", err.message);
      })
      .finally(() => setDetailsLoading(false));
  }, [itemId]);

  useEffect(() => {
    getSinglePayout();
  }, []);

  console.log("payoutItem :", payoutItem);

  return (
    <div className="payout-details-wrapper">
      {detailsLoading && (
        <p className="loading-text text-center">
          {" "}
          <FontAwesomeIcon icon={faSpinner} spin />
        </p>
      )}

      {!detailsLoading && (
        <>
          <div className="payout-heading">
            <div className={`payout-status ${payoutItem?.status}`}>
              {payoutItem?.status === "processing" ? "Processing" : "Completed"}
              {/* <span>#{payoutItem?.stripePayoutId}</span> */}
            </div>
            <div className="payout-date-time">
              {moment(payoutItem?.payoutDate).format("DD MMM YYYY")}
            </div>
          </div>

          <div className="payout-items-wrapper">
            <div className="payout-separator" />

            <div className="payout-item">
              <p>Requested Amount</p>
              <span>${payoutItem?.netAmount}</span>
            </div>

            <div className="payout-separator" />

            <div className="payout-item">
              <p>Tax</p>
              <span>- ${payoutItem?.taxFee}</span>
            </div>

            <div className="payout-separator" />

            <div className="payout-item">
              <p>Fees</p>
              {payoutItem && (
                <span>
                  - $
                  {Number(
                    parseFloat(payoutItem?.platformFee) +
                      parseFloat(payoutItem?.stripeFee)
                  ).toFixed(2)}
                </span>
              )}
            </div>
            <div className="payout-item sub-item">
              <p>Platform Fee</p>
              <span>- ${payoutItem?.platformFee}</span>
            </div>

            <div className="payout-item sub-item">
              <p>Stripe Fees</p>
              <span>- ${payoutItem?.stripeFee}</span>
            </div>

            <div className="payout-total-item">
              <p>Payout Total</p>
              <span>${payoutItem?.grossAmount}</span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PayoutDetails;
